var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"main-content",attrs:{"align-left":""}},[_c('app-icon'),_c('div',{staticClass:"tabs-wrap"}),_c('app-drop-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }